import NAME from "./constants";

export const RESET_ALL = NAME + "/RESET_ALL";

// modules
export const GET_MODULES = NAME + "/GET_MODULES";
export const GET_MODULES_REJECTED = NAME + "/GET_MODULES_REJECTED";
export const GET_MODULES_FULFILLED = NAME + "/GET_MODULES_FULFILLED";

export const UPDATE_MODULE = NAME + "/UPDATE_MODULE";
export const UPDATE_MODULE_REJECTED = NAME + "/UPDATE_MODULE_REJECTED";
export const UPDATE_MODULE_FULFILLED = NAME + "/UPDATE_MODULE_FULFILLED";

// menus
export const GET_MENUS = NAME + "/GET_MENUS";
export const GET_MENUS_REJECTED = NAME + "/GET_MENUS_REJECTED";
export const GET_MENUS_FULFILLED = NAME + "/GET_MENUS_FULFILLED";

export const UPDATE_MENU = NAME + "/UPDATE_MENU";
export const UPDATE_MENU_REJECTED = NAME + "/UPDATE_MENU_REJECTED";
export const UPDATE_MENU_FULFILLED = NAME + "/UPDATE_MENU_FULFILLED";

// exclusions
export const GET_EXCLUSIONS = NAME + "/GET_EXCLUSIONS";
export const GET_EXCLUSIONS_REJECTED = NAME + "/GET_EXCLUSIONS_REJECTED";
export const GET_EXCLUSIONS_FULFILLED = NAME + "/GET_EXCLUSIONS_FULFILLED";

export const CREATE_EXCLUSIONS = NAME + "/CREATE_EXCLUSIONS";
export const CREATE_EXCLUSIONS_REJECTED = NAME + "/CREATE_EXCLUSIONS_REJECTED";
export const CREATE_EXCLUSIONS_FULFILLED = NAME + "/CREATE_EXCLUSIONS_FULFILLED";

export const UPDATE_EXCLUSIONS = NAME + "/UPDATE_EXCLUSIONS";
export const UPDATE_EXCLUSIONS_REJECTED = NAME + "/UPDATE_EXCLUSIONS_REJECTED";
export const UPDATE_EXCLUSIONS_FULFILLED = NAME + "/UPDATE_EXCLUSIONS_FULFILLED";

export const DELETE_EXCLUSIONS = NAME + "/DELETE_EXCLUSIONS";
export const DELETE_EXCLUSIONS_REJECTED = NAME + "/DELETE_EXCLUSIONS_REJECTED";
export const DELETE_EXCLUSIONS_FULFILLED = NAME + "/DELETE_EXCLUSIONS_FULFILLED";

export const DUPLICATE_EXCLUSIONS = NAME + "/DUPLICATE_EXCLUSIONS";
export const DUPLICATE_EXCLUSIONS_REJECTED = NAME + "/DUPLICATE_EXCLUSIONS_REJECTED";
export const DUPLICATE_EXCLUSIONS_FULFILLED = NAME + "/DUPLICATE_EXCLUSIONS_FULFILLED";

// tree
export const GET_TREE = NAME + "/GET_TREE";
export const GET_TREE_REJECTED = NAME + "/GET_TREE_REJECTED";
export const GET_TREE_FULFILLED = NAME + "/GET_TREE_FULFILLED";